module.exports = __webpack_public_path__ + "img/tabRight.633724d4.png";